/* =============================================
   AURA6 — SHOPIFY THEME JS (matches local)
   ============================================= */
(function () {
  'use strict';

  /* ---- Navbar scroll ---- */
  const nb = document.getElementById('navbar');
  if (nb) {
    const heroEl = document.getElementById('hero');
    if (heroEl) {
      new IntersectionObserver(
        ([e]) => nb.classList.toggle('solid', !e.isIntersecting),
        { threshold: 0.05 }
      ).observe(heroEl);
    }
  }

  /* ---- Fade-up ---- */
  const fuObs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('show'); });
  }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
  document.querySelectorAll('.fu').forEach(el => fuObs.observe(el));

  /* ---- Hero video autoplay fallback ---- */
  const heroVid = document.getElementById('hero-vid');
  if (heroVid) {
    heroVid.play().catch(() => {
      heroVid.muted = true;
      heroVid.play().catch(() => {});
    });
  }

  /* ---- Auto-play videos when scrolled into view (50% threshold) ---- */
  // Matches local version: plays muted on scroll, hides play button, pauses on scroll-out
  const autoPlayVideos = document.querySelectorAll(
    '.film-card video, .roll-clip video, .noreplay-vid-wrap video'
  );
  const vpObs = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const vid = entry.target;
      const parent = vid.closest('.film-card, .roll-clip, .noreplay-vid-wrap');
      if (entry.isIntersecting) {
        vid.play().then(() => {
          if (parent) parent.classList.add('playing');
        }).catch(() => {});
      } else {
        vid.pause();
        if (parent) parent.classList.remove('playing');
      }
    });
  }, { threshold: 0.5 });
  autoPlayVideos.forEach(v => vpObs.observe(v));

  /* ---- Manual play toggle (click to pause/resume) ---- */
  // Works for film cards, roll clips, and noreplay wrap
  document.querySelectorAll('.film-card .play-overlay, .roll-clip .play-overlay, .noreplay-vid-wrap .play-overlay').forEach(btn => {
    btn.addEventListener('click', () => {
      const parent = btn.closest('.film-card, .roll-clip, .noreplay-vid-wrap');
      if (!parent) return;
      const vid = parent.querySelector('video');
      if (!vid) return;
      if (vid.paused) {
        vid.play().then(() => parent.classList.add('playing')).catch(() => {});
      } else {
        vid.pause();
        parent.classList.remove('playing');
      }
    });
  });

  /* ---- Film strip drag scroll ---- */
  const strip = document.getElementById('film-strip');
  if (strip) {
    let isDown = false, startX = 0, scrollLeft = 0;
    strip.addEventListener('mousedown', e => {
      isDown = true; startX = e.pageX - strip.offsetLeft; scrollLeft = strip.scrollLeft;
    });
    strip.addEventListener('mouseleave', () => { isDown = false; });
    strip.addEventListener('mouseup', () => { isDown = false; });
    strip.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      strip.scrollLeft = scrollLeft - (e.pageX - strip.offsetLeft - startX) * 1.5;
    });
  }

  /* ---- 6-second countdown animation ---- */
  const sixNum = document.getElementById('six-num');
  const sixBar = document.getElementById('six-bar');
  const sixFrames = document.querySelectorAll('#six-frames .six-frame');
  if (sixNum && sixBar && sixFrames.length) {
    let count = 6, filledFrames = 0, running = false;

    function runCountdown() {
      if (running) return;
      running = true;
      count = 6;
      filledFrames = 0;
      sixBar.style.width = '100%';
      sixNum.textContent = '6';
      sixFrames.forEach(f => f.classList.remove('empty'));

      const interval = setInterval(() => {
        count--;
        sixNum.textContent = count;
        sixBar.style.width = (count / 6 * 100) + '%';
        filledFrames++;
        if (sixFrames[filledFrames - 1]) sixFrames[filledFrames - 1].classList.add('empty');
        if (count <= 0) {
          clearInterval(interval);
          setTimeout(() => { running = false; }, 1500);
        }
      }, 850);
    }

    const sixSection = document.getElementById('six');
    if (sixSection) {
      new IntersectionObserver(([e]) => {
        if (e.isIntersecting) runCountdown();
      }, { threshold: 0.4 }).observe(sixSection);
    }
  }

  /* ---- Forms: no JS handlers needed ---- */
  // Both hero and waitlist forms use {% form 'customer' %} natively.
  // Shopify injects the authenticity_token via content_for_header JS and handles
  // the POST. Success state is rendered server-side via form.posted_successfully?
  // Scroll to waitlist success message if it appeared after page reload
  const wlSuccess = document.getElementById('wl-success');
  if (wlSuccess) {
    wlSuccess.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

})();
